// The employment-history step of the driver application.
//
// The accordion this replaced is gone. It asked for sixteen fields per employer
// on one long page, collected a contact only after a DOT number had been
// matched, and saved nothing until the driver pressed Continue.

import ApplicationScreenWrapper from '../components/ApplicationScreenWrapper'
import { EmploymentHistoryScreen } from '../employment/EmploymentHistoryScreen'
import { useFormLeaveGuard } from '../hooks/useLeaveGuard'
import { useFormContext } from '../utils/FormContext'
import { buildEmploymentPayload } from '../utils/stepPayloads'

export const MainEmploymentScreen = () => {
  const {
    form,
    handleNext,
    updateLoading,
    application,
    applicationId,
    saveProgress,
    saveProgressLoading,
    backText,
  } = useFormContext()
  const { goBack, leaveGuardModal } = useFormLeaveGuard(
    (values) => ({ ...buildEmploymentPayload(values), partialSave: true })
  )

  return (
    <ApplicationScreenWrapper
      title="Employment History"
      application={application}
      // The mobile chevron renders regardless; without this it hits the
      // wrapper's no-op default and back navigation is silently dead
      goBack={goBack}
      hideButtons
      fullBleed
    >
      {leaveGuardModal}
      <EmploymentHistoryScreen
        experiences={form.values.employmentExperiences}
        onExperiencesChange={(experiences) =>
          form.setFieldValue('employmentExperiences', experiences)
        }
        requiredYears={
          application?.applicant?.jobListing?.minEmploymentHistoryYears ?? null
        }
        busy={updateLoading || saveProgressLoading}
        submit={(payload) =>
          saveProgress({
            variables: {
              id: applicationId,
              // A draft, not a submission: the API's coverage check would
              // otherwise reject the first employer a driver enters, for any
              // company that requires a minimum history
              input: { ...(payload as object), partialSave: true },
            },
          })
        }
        onContinue={() => handleNext(buildEmploymentPayload(form.values))}
        onBack={goBack}
        backText={backText}
      />
    </ApplicationScreenWrapper>
  )
}
